<template>
  <div
    v-tooltip="!complex ? errorMessage : ''"
    class="error"
    :class="{ complex: complex }">
    <template v-if="complex">
      <icon-complex-sad />
      <p>{{ errorMessage }}</p>
    </template>
    <icon-colored-sad v-else />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  import { IconColoredSad } from '@/common/icons/colored';
  import { IconComplexSad } from '@/common/icons/complex';
  import { i } from '@/globals';

  const errorMessageKey = 'messages.mediaFileNotLoading';

  interface IProps {
    complex?: boolean;
  }

  const { complex = false } = defineProps<IProps>();

  const errorMessage = computed(() => i(errorMessageKey));
</script>

<style lang="scss" scoped>
  .error {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    flex-direction: column;

    &.complex {
      padding: 1rem;
    }

    svg {
      height: 4.8rem;
      width: 4.8rem;
    }
  }
</style>
